// extracted by mini-css-extract-plugin
export var container = "WithdrawableBalance-module--container--d4225";
export var label = "WithdrawableBalance-module--label--4db53";
export var skeleton = "WithdrawableBalance-module--skeleton--4ce92";
export var supportLink = "WithdrawableBalance-module--supportLink--ba078";